<template>
    <sui-segment :loading="is_loading">
        <h1 is="sui-header">{{ $t('users.list.title') }}</h1>

        <sui-card class="fluid">
            <sui-card-content>
                <sui-form @submit="(e) => e.preventDefault()">
                    <sui-form-field>
                        <sui-checkbox :label="$t('users.list.showOnlyDisabled')" toggle
                                      v-model="query.inactive_only"/>
                    </sui-form-field>

                    <sui-form-field>
                        <label>{{ $t('users.list.searchByMail') }}</label>
                        <div class="ui fluid action input">
                            <sui-input :value="query.email" @input="onSearchEmailChange"/>
                            <sui-button v-on:click="resetSearchMail()" icon="trash"/>
                        </div>
                    </sui-form-field>

                    <sui-form-field>
                        <label>{{ $t('users.list.searchByName') }}</label>
                        <div class="ui fluid action input">
                            <sui-input :value="query.name" @input="onSearchNameChange"/>
                            <sui-button v-on:click="resetSearchName()" icon="trash"/>
                        </div>
                    </sui-form-field>

                    <sui-form-field>
                        <label>{{ $t('users.list.searchByAgency') }}</label>
                        <div class="ui fluid action input">
                            <sui-input :value="query.agency" @input="onSearchAgencyChange"/>
                            <sui-button v-on:click="resetSearchAgency()" icon="trash"/>
                        </div>
                    </sui-form-field>
                </sui-form>
            </sui-card-content>
        </sui-card>

        <Paginator :current.sync="pagination.page" :total="total" :size="pagination.pageSize" />

        <sui-table class="compact" celled striped>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell>{{ $t('common.id') }}</sui-table-header-cell>
                    <sui-table-header-cell>Mail</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('common.name') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('users.list.agencies') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('users.list.enabled') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('users.list.emails') }}</sui-table-header-cell>
                    <sui-table-header-cell>{{ $t('users.list.actions') }}</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>

            <!-- Table Body -->

            <sui-table-body>

                <sui-table-row v-for="user in users" :key="user.id">
                    <sui-table-cell>{{ user.id }}</sui-table-cell>
                    <sui-table-cell>{{ user.email }}</sui-table-cell>
                    <sui-table-cell>{{ user.firstName }} {{ user.lastName }}</sui-table-cell>
                    <sui-table-cell>
                        <sui-list bulleted>
                            <sui-list-item v-for="customer in user.customers" :key="customer.id">
                                {{customer.name}} <sui-label>#{{customer.id}}</sui-label>
                            </sui-list-item>
                        </sui-list>
                    </sui-table-cell>
                    <sui-table-cell>
                        <sui-label v-if="user.isCreated" color="green">{{ $t('common.yes') }}</sui-label>
                        <sui-label v-else color="red">{{ $t('common.no') }}</sui-label>
                    </sui-table-cell>
                    <sui-table-cell>
                        <sui-button class="tiny" fluid v-on:click="openModal(user)">
                            {{ $t('users.list.see') }}
                        </sui-button>
                    </sui-table-cell>
                    <sui-table-cell>
                        <sui-button class="tiny red" fluid icon="trash" v-on:click="deleteUser(user)">
                        </sui-button>
                    </sui-table-cell>
                </sui-table-row>

            </sui-table-body>
        </sui-table>

        <Paginator :current.sync="pagination.page" :total="total" :size="pagination.pageSize" />

        <sui-modal v-model="modal_opened">
            <div class="my-modal">
                <h4 v-if="modal_user">{{ $t('users.list.mailsSentTo', { email: modal_user.email }) }}</h4>
                <sui-table class="compact" celled striped>
                    <sui-table-header>
                        <sui-table-row>
                            <sui-table-header-cell>{{ $t('users.list.sendBy') }}</sui-table-header-cell>
                            <sui-table-header-cell>{{ $t('users.list.subject') }}</sui-table-header-cell>
                            <sui-table-header-cell>{{ $t('common.status') }}</sui-table-header-cell>
                            <sui-table-header-cell>{{ $t('users.list.openCount') }}</sui-table-header-cell>
                            <sui-table-header-cell>{{ $t('users.list.clickCount') }}</sui-table-header-cell>
                            <sui-table-header-cell>{{ $t('users.list.lastEvent') }}</sui-table-header-cell>
                        </sui-table-row>
                    </sui-table-header>
                    <sui-table-body>
                        <sui-table-row v-for="mail in user_mails" :key="mail.msg_id">
                            <sui-table-cell>{{ mail.from_email }}</sui-table-cell>
                            <sui-table-cell>{{ mail.subject }}</sui-table-cell>
                            <sui-table-cell>{{ mail.status }}</sui-table-cell>
                            <sui-table-cell>{{ mail.opens_count }}</sui-table-cell>
                            <sui-table-cell>{{ mail.clicks_count }}</sui-table-cell>
                            <sui-table-cell>{{ mail.lastEventString }}</sui-table-cell>
                        </sui-table-row>
                    </sui-table-body>
                </sui-table>
            </div>
        </sui-modal>

    </sui-segment>
</template>


<style scoped>
.pill {
    background-color: green;
    border-radius: 5px;
    padding: 5px;
    color: white;
    display: flex;
    justify-content: center;
}

.error {
    background-color: red !important;
}

.my-modal {
    padding: 30px;
}
</style>

<script>
import { api } from '@/api';
import { debounce } from '@/utils';
import store from '@/store';
import Paginator from '@/components/Paginator.vue';

export default {
    name: 'UsersList',
    components: {
        Paginator,
    },
    beforeDestroy() {
        store.commit('removeAppTitle');
    },
    data() {
        return {
            // TODO: optimiser ça, désolé je prends pas trop le temps de regarder mais ça doit pas être si compliqué.
            onSearchEmailChange: debounce((value) => {
                this.query.email = value;
                this.pagination.page = 1;
            }, 400),
            onSearchNameChange: debounce((value) => {
                this.query.name = value;
                this.pagination.page = 1;
            }, 400),
            onSearchAgencyChange: debounce((value) => {
                this.query.agency = value;
                this.pagination.page = 1;
            }, 400),
            users: [],
            is_loading: true,
            modal_opened: false,
            user_mails: [],
            modal_user: null,
            total: 0,
            pagination: {
                page: 1,
                pageSize: 50,
            },
            query: {
                inactive_only: false,
                email: null,
                name: null,
                agency: null
            }
        }
    },
    mounted() {
        store.commit('setAppTitle', `${this.$t('common.users')}`);
    },
    watch: {
        query: {
            handler() {
                this.pagination.page = 1;
                this.getUsers();
            },
            immediate: false,
            deep: true,
        },
        pagination: {
            handler() {
                this.$emit('paginationChange', this.pagination);
                this.getUsers();
            },
            immediate: true,
            deep: true,
        }
    },
    methods: {
        async getUsers() {
            this.is_loading = true;
            try {
                const response = await api.users.fetch({
                    ...this.query,
                    ...this.pagination,
                });

                this.users = response.items;
                this.total = response.total;
            } finally {
                this.is_loading = false;
            }
        },

        joinCustomers(user) {
            return user.customers.map((c) => c.name).join(' ');
        },

        resetSearchName() {
            this.query.name = null;
        },

        resetSearchMail() {
            this.query.email = null;
        },

        resetSearchAgency() {
            this.query.agency = null;
        },

        async openModal(user) {
            this.modal_user = user;
            this.is_loading = true;
            try {
                const { messages } = await api.users.mails(user.id);
                this.user_mails = messages;
                this.user_mails.forEach((m) => {
                    const date = new Date(m.last_event_time);
                    m.lastEventString = `${date.getHours()}:${date.getMinutes()}, ${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
                });
                this.modal_opened = true;
            } finally {
                this.is_loading = false;
            }
        },

        async deleteUser(user) {
            this.is_loading = true;
            try {
                await api.users.remove(user.id);
                await this.getUsers();
                this.$toastr.s(this.$t('users.list.userSuccessfullyRemoved', { user: user.email }));
            } catch(error) {
                let errorMessage = error.message
                if(error.response.data) {
                    errorMessage += ` (${error.response.data})`;
                }
                this.$toastr.e(this.$t('users.list.cannotRemoveUser', { error:errorMessage }));
            } finally {
                this.is_loading = false;
            }
        }
    }
}
</script>
